 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <el-page-header @back="goBack" content="问候短信定时任务"></el-page-header>
        <div class="buttons"  :style="{position: button_position}">

        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20 search" :gutter="20">
            <el-col :md="5" :lg="4" :xl="4" :sm="6" :xs="12">
                <span class="fs-14 pd-r-10">任务类型：</span>
                <el-select
                    clearable
                    class="status" v-model="status" placeholder="请选择任务类型" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="5" :lg="4" :xl="4" :sm="6" :xs="12">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>


        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  @selection-change="selectUsers"
                  style="width: 100%">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="170" prop="title" label="任务描述" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="name" label="名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="message_content" label="短信内容" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110" prop="is_push_txt" label="系统消息推送" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="send_time" label="发送时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="80" prop="status_txt" label="任务状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                width="140"
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button @click="sendPromition(scope.row)" v-if="scope.row.status == 1" type="text" size="mini">立即发送</el-button>
                <el-button @click="cancelPromition(scope.row)" v-if="scope.row.status == 1" type="text" size="mini">取消发送</el-button>
                <el-button @click="editInterval(scope.row)" v-if="scope.row.status == 1" type="text" size="mini">编辑</el-button>
                <el-button @click="showInterval(scope.row)" type="text" size="mini">详情</el-button>
                <el-button @click="delPromition(scope.row)" type="text" size="mini">删除</el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
        <el-dialog
            :title="dialog_title"
            :visible.sync="dialogVisible"
            width="30%"
            id="sms_dialog"
            @close="dialogClose"
            center>
            <el-form label-position="right" :model="smsForm" :rules="smsRules" ref="smsForm"
                     label-width="100px"
                     class="form" style="width: 90%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="发送时间" prop="send_time">
                    <el-date-picker
                        v-model="smsForm.send_time"
                        type="datetime"
                        default-time="8:00:00"
                        placeholder="选择发送时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="问候用户" prop="user_ids" v-if="!is_sms_send_all">
                    <el-select v-model="smsForm.user_ids"
                               multiple
                               placeholder="请选择问候用户"
                               style="width: 100%;">
                        <el-option
                            v-for="item in allUsers"
                            :key="item.user_id"
                            :label="item.user_name"
                            :value="item.user_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问候用户" prop="sms_type" v-if="is_sms_send_all">
                    <el-select v-model="smsForm.sms_type" placeholder="请选择发送短信"
                               style="width: 100%;">
                        <el-option
                            v-for="item in allSmsRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问候短信" prop="template_id" class="sms_template" style="margin-bottom: 0;">
                    <el-select v-model="smsForm.template_id" placeholder="请选择发送短信"
                               style="width: 100%;" @change="selectSms">
                        <el-option
                            v-for="item in allSmsTmpl"
                            :key="item.template_id"
                            :label="item.name"
                            :value="item.template_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="短信内容">
                    <el-input class="sms_textarea" type="textarea" :autosize="true" v-model="smsForm.sms_content" :disabled="true" autocomplete="off"
                              style="width: calc(100% - 10px);"></el-input>
                </el-form-item>
                <el-form-item label="系统消息推送" prop="status">
                    <el-radio-group v-model="smsForm.is_push">
                        <el-radio :label="1">推送</el-radio>
                        <el-radio :label="2">不推送</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="success" @click="updatePromotionSms('smsForm')">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog  id="view_user" :title="interval_title" :visible.sync="intervalVisible" @close="dialogClose">
            <p style="text-align: left;font-size: 1.1em;">
                用户成功收到短信：{{recive_count}}&ensp;&ensp;&ensp;&ensp;
                黑名单拦截：{{black_count}}&ensp;&ensp;&ensp;&ensp;
                关键字拦截：{{key_count}}&ensp;&ensp;&ensp;&ensp;
                不在服务区：{{offline_count}}&ensp;&ensp;&ensp;&ensp;
                超限：{{limit_count}}&ensp;&ensp;&ensp;&ensp;
                其他：{{other_count}}
            </p>
            <el-table :data="intervalDetailList" border style="width: 100%">
                <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="100" prop="user_name" label="用户姓名" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="140" prop="mobile" label="手机号" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="140" prop="role_text" label="角色类型" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="140" prop="name" label="名称" align="center" label-class-name="label"></el-table-column>
                <el-table-column  prop="result_code" label="发送结果" align="center" label-class-name="label"></el-table-column>
                <el-table-column width="160" prop="create_date" label="发送时间" align="center" label-class-name="label"></el-table-column>
            </el-table>
            <el-pagination class="mg-20 ta-r" background layout="total, sizes, prev, pager, next, jumper"
                           :page-sizes="[5, 10,15]" :total="total_interval" :page-size="perpage_interval"
                           :current-page="page_interval"
                           @current-change="intervalChangePage($event, 'current_page')" @size-change="intervalChangePage($event, 'page_size')"
                           v-if="total_interval >= 5"></el-pagination>
        </el-dialog>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allSmsTmpl: [],
                user_name: '',
                mobile: '',
                status: '',
                allStatus: [
                    {
                        id: '1',
                        name: '待发送'
                    },
                    {
                        id: '2',
                        name: '已撒送'
                    },
                    {
                        id: '3',
                        name: '已取消'
                    },
                ],
                allSmsRole: [
                    {
                        id: '6',
                        name: '所有用户'
                    },
                    {
                        id: '1',
                        name: '特属服务对象'
                    },
                    {
                        id: '3',
                        name: '特属专家'
                    },
                ],
                smsForm: {
                    id: '',
                    user_ids: [],
                    template_id: '',
                    sms_type: 0,
                    sms_content: '',
                    send_time: '',
                    status: '',
                    is_push: 2,
                },
                smsRules: {
                    user_ids: [
                        {required: true, message: "请选择问候用户", trigger: "blur"},
                    ],
                    sms_type: [
                        {required: true, message: "请选择问候用户", trigger: "blur"},
                    ],
                    template_id: [
                        {required: true, message: "请选择需要发送的短信", trigger: "blur"},
                    ],
                    send_time: [
                        {required: true, message: "请选择发送时间", trigger: "blur"},
                    ],
                },
                button_position: 'absolute',
                is_mobile: false,
                is_submit: false,
                dialogVisible: false,
                dialog_title: '',
                is_sms_send_all: '',
                allUsers: [],
                intervalDetailList: [],
                interval_title: '',
                intervalVisible: false,
                page_interval: 1,
                perpage_interval: 10,
                total_interval: 0,
                interval_id: 0,
                recive_count: 0,
                black_count: 0,
                key_count: 0,
                offline_count: 0,
                limit_count: 0,
                other_count: 0,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
        },
        mounted() {
            // 获取列表
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'system_message_add' || prev_page == 'sms_list') {
                this.user_name = localStorage.getItem('sms_user_name')
                this.mobile = localStorage.getItem('sms_mobile')
                this.role_type = localStorage.getItem('sms_type')
                if (this.mobile == 'undefined' || this.mobile == 'null') {
                    this.mobile = ''
                }
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.role_type == 'undefined' || this.role_type == 'null') {
                    this.role_type = ''
                }
                if (this.role_type) {
                    this.role_type = parseInt(this.role_type)
                }
            }
            this.getAllUsers()
            this.getList();
            this.smsTmpl();
        },
        methods: {
            dialogClose(){
                // 关闭编辑弹窗
                this.smsForm.id = ''
                this.smsForm.user_ids = [];
                this.smsForm.template_id = ''
                this.smsForm.sms_type = ''
                this.smsForm.send_time = ''
                this.smsForm.status = ''
                this.dialogVisible = false
                this.dialog_title = ''
                this.is_sms_send_all = false

                // 关闭定时任务发送详情弹窗
                this.page_interval = 1
                this.perpage_interval = 10
                this.total_interval = 0
                this.intervalDetailList = []
                this.intervalVisible = false
            },
            editInterval(data) {
                this.dialog_title = ` ${data.name}（${data.send_time}发送）`
                if (data.type == 9) {
                    this.is_sms_send_all = false
                } else {
                    this.is_sms_send_all = true
                }
                this.smsForm.id = data.id
                this.smsForm.user_ids = JSON.parse(data.user_ids);
                this.smsForm.template_id = data.template_id
                this.smsForm.sms_type = data.type
                this.smsForm.send_time = data.send_time
                this.smsForm.status = data.status
                this.smsForm.sms_content = data.message_content
                this.smsForm.is_push = parseInt(data.is_push)||2
                this.dialogVisible = true
            },
            showInterval(data) {
                if (data.title) {
                    this.interval_title = ` ${data.title}`
                } else {
                    this.interval_title = ` ${data.name}`
                }

                this.interval_id = data.id
                this.page_interval = 1
                this.perpage_interval = 10
                this.total_interval = 0
                this.intervalDetailList = []
                this.intervalVisible = true
                this.intervalDetail()
            },
            intervalDetail() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'getUserSmsList',
                    pageinfo: {
                        page: this.page_interval,
                        perpage: this.perpage_interval,
                    },
                    params: {
                        interval_id: this.interval_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].no = (this.page_interval - 1) * this.perpage_interval + i + 1
                    }
                    this.intervalDetailList = res.data.data.list;
                    this.recive_count = res.data.data.count.recive_count;
                    this.black_count = res.data.data.count.black_count;
                    this.key_count = res.data.data.count.key_count;
                    this.offline_count = res.data.data.count.offline_count;
                    this.limit_count = res.data.data.count.limit_count;
                    this.other_count = res.data.data.count.other_count;
                    this.total_interval = res.data.data.page.count;
                });
            },
            intervalChangePage(index, change_type){
                if (change_type == 'current_page') {
                    this.page_interval= index
                } else if (change_type == 'page_size') {
                    this.perpage_interval = index
                }
                this.intervalDetail()
            },
            // 返回上一页
            goBack() {
                window.history.go(-1);
                return;
            },
            getAllUsers() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'getSmsUser',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allUsers = res.data.data.list;
                });
            },
            smsTmpl() {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'smsTmplList',
                    params: {
                        type: "send_promotion_sms"
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allSmsTmpl = res.data.data.list;
                });
            },
            cancelPromition(data) {
                this.$confirm(`是否立即取消：${data.name} 短信发送`, '提示', {
                    confirmButtonText: '取消发送',
                    cancelButtonText: '不取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_ContentServices',
                        method: 'updatePromotionInterval',
                        params: {
                            id: data.id,
                            status: '3',
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: `${data.name} 短信已取消发送`,
                            duration: 1500,
                        });
                        this.getList();
                    }).catch(() => {
                    })
                }).catch(() => {
                })
            },
            delPromition(data) {
                let message = `是否立即删除：${data.name} 短信任务`
                if (data.status == 1) {
                    message = `${data.name} 短信任务还未执行，是否立即删除`
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_ContentServices',
                        method: 'updatePromotionInterval',
                        params: {
                            id: data.id,
                            status: '0',
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: `${data.name} 短信任务已删除`,
                            duration: 1500,
                        });
                        this.getList();
                    }).catch(() => {
                    })
                }).catch(() => {
                })
            },
            sendPromition(data) {
                this.$confirm(`是否立即执行：${data.name} 定时任务`, '提示', {
                    confirmButtonText: '立即执行',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_ContentServices',
                        method: 'PromotionInterval',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '发送成功',
                            duration: 1500,
                        });
                        this.getList();
                    }).catch(() => {
                    })
                }).catch(() => {
                })
            },
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'promotionIntervalList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        status: this.status,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                if (res.data.data.list[i].last_send_time) {
                                    res.data.data.list[i].status_txt = '正在发送';
                                } else {
                                    res.data.data.list[i].status_txt = '待发送';
                                }
                                break;
                            case '2':
                                res.data.data.list[i].status_txt = '已发送';
                                break;
                            case '3':
                                res.data.data.list[i].status_txt = '已取消';
                                break;
                        }
                        if (parseInt(res.data.data.list[i].is_push) === 1) {
                            res.data.data.list[i].is_push_txt = '推送'
                        } else {
                            res.data.data.list[i].is_push_txt = '不推送'
                        }
                    }

                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.status = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },


            goUserList(data) {
                this.$router.push({
                    name: "userSmsList", params: {
                        user_id: data.user_id,
                        user_name: data.user_name,
                        mobile: data.mobile,
                        user_role: data.role_type,
                    }
                });
            },
            selectUsers(data) {
                let len = data.length
                this.smsForm.user_ids = [];
                this.smsForm.sms_type = 9
                for (let i = 0; i < len; i++) {
                    this.smsForm.user_ids.push(data[i].user_id)
                }
            },
            selectSms(){
                let len = this.allSmsTmpl.length
                console.log(this.smsForm.template_id, len)
                for (let i = 0; i < len; i++) {
                    if (this.allSmsTmpl[i].template_id == this.smsForm.template_id) {
                        this.smsForm.sms_content = this.allSmsTmpl[i].content
                    }
                }

            },
            // 发送短信
            sendSms(type) {
                if (type !== 'all' && type !== 'interval_all' && this.smsForm.user_ids.length < 1) {
                    this.$message({
                        type: "warning",
                        message: '请选择需要发送问候短信的用户',
                        duration: 1500,
                    });
                    return;
                }
                this.smsForm.template_id = ''
                this.smsForm.sms_content = ''
                switch (type) {
                    case 'interval_all':
                        this.is_interval = true;
                        this.is_sms_send_all = true
                        this.dialog_title = '定时批量发送问候短信'
                        this.smsRules.sms_type = ''
                        break;
                    case 'interval_multi':
                        this.is_interval = true;
                        this.is_sms_send_all = false
                        this.dialog_title = '定时群发问候短信'
                        this.smsForm.sms_type = 6
                        break;
                    case 'all':
                        this.is_sms_send_all = true
                        this.dialog_title = '群发问候短信'
                        this.smsForm.sms_type = ''
                        break
                        break
                    case 'multi':
                        this.is_sms_send_all = false
                        this.dialog_title = '批量发送问候短信'
                        this.smsRules.sms_type = 6
                }

                this.dialogVisible = true
            },
            updatePromotionSms(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }

                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_ContentServices',
                            'method': 'updatePromotionInterval',
                            'params': {
                                user_ids: this.smsForm.user_ids,
                                type: this.smsForm.sms_type,
                                template_id: this.smsForm.template_id,
                                send_time: this.smsForm.send_time,
                                status: this.smsForm.status,
                                is_push: this.smsForm.is_push,
                                id: this.smsForm.id,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '修改成功',
                                duration: 1500,
                                onClose: function () {
                                    _that.is_submit = false;
                                    _that.dialogVisible = false;
                                    _that.dialogClose()
                                    _that.getList()
                                    return;
                                }
                            });
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        console.log(valid)
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                })
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-select.status .el-input {
        width: 100%;
    }
    .search .el-input {
        width: 100% !important;
    }
    .sms_textarea{
        textarea.el-textarea__inner {
            background-color: #FFFFFF !important;
            color: #000000 !important;
        }
    }
    #sms_dialog{
        .el-dialog{
            min-width: 560px;
        }
    }
</style>
